import * as PourOver from 'pourover';

import { FilterBase } from './FilterBase';

export class ComplianceFilter extends FilterBase {
  needsSubset = true;

  excludedFromCompliance: any;
  includedInCompliance: any;

  makeIndex(): any {
    // Every incumbent falls into only one of these categories.
    return new PourOver.makeExactFilter('exclude', [true, false]);
  }

  getMatchSet(collection: any, filterSettings): any {
    this.includedInCompliance = collection.filters.exclude.getFn(false);
    this.excludedFromCompliance = collection.filters.exclude.getFn(true);

    if (
      filterSettings.showIncludedInCompliance &&
      filterSettings.showExcludedFromCompliance
    ) {
      return this.includedInCompliance.or(this.excludedFromCompliance);
    } else if (filterSettings.showIncludedInCompliance) {
      return this.includedInCompliance;
    } else if (filterSettings.showExcludedFromCompliance) {
      return this.excludedFromCompliance;
    }
  }

  getCounts(filterCombinations): any {
    let intersectionMinusThisFilter =
      filterCombinations.subsets[this.constructor.name];
    let incumbentsFilter = filterCombinations.incumbentsFilter;

    let temp = intersectionMinusThisFilter
      ? intersectionMinusThisFilter.and(incumbentsFilter)
      : incumbentsFilter;

    return {
      excludedFromCompliance: temp.and(this.excludedFromCompliance).cids.length,
      includedInCompliance: temp.and(this.includedInCompliance).cids.length
    };
  }
}
